import { readFrameData } from "../../../lib/frame-data";
import type { PartnerBranding } from "../../../lib/partner-branding";
import type { AuthTypesResponse } from "./auth-data.types";

function optionalString(value: unknown): string | undefined {
  return typeof value === "string" ? value : undefined;
}

/** The auth-types the server put in the page, or null. */
export function pageAuthTypes(): AuthTypesResponse | null {
  const authTypes = readFrameData().auth?.authTypes?.authTypes;
  const types = authTypes?.types;
  if (!Array.isArray(types) || !types.every((type) => type === "otp" || type === "email")) {
    return null;
  }
  return {
    authTypes: {
      types,
      maskedEmail: optionalString(authTypes?.maskedEmail),
      maskedPhoneNumber: optionalString(authTypes?.maskedPhoneNumber),
      termsAcceptedAt: optionalString(authTypes?.termsAcceptedAt),
    },
  };
}

/** The partner's name and logo the server put in the page, or null. */
export function pageAccount(): PartnerBranding | null {
  const account = readFrameData().auth?.account;
  if (typeof account?.name !== "string") {
    return null;
  }
  return { name: account.name, iconUrl: optionalString(account.iconUrl) ?? "" };
}
